import React, { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import { Suspense, lazy } from 'react';
import logo from '../src/img/agrya-logo.png';
import "./AdminPanel.css";
import { usePocketBase } from './PocketBaseProvider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SmsIcon from '@mui/icons-material/Sms';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StorageIcon from '@mui/icons-material/Storage';
import PollIcon from '@mui/icons-material/Poll';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import SysCheck from './SysCheck';
import { useThemeMode } from './themeModeContext';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

const SMSDialog = lazy(() => import('./SmsSender'));

function NagyNav() {

  const softCheckForbidden = [ "/admin/", "userSearch", "surveys", "surveyMaker", "uj", "szerkesztes", "vfs" ];

  const { mode, toggleMode } = useThemeMode();
  const pb = usePocketBase();

  useEffect(() => {
    console.log("NavBar authStore change effect, isValid: ", pb.authStore.isValid);
  if (!pb.authStore.isValid  && softCheckForbidden.some(word => window.location.href.includes(word))) {
    window.location.href = "/";
  }
  }, [pb.authStore.isValid]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <div style={{ display: "flex", alignItems: "left"}}>
          <img src={logo} alt="Logo" width="auto" height="50" style={{ margin: "10px"}} onClick={() => window.location.href="/#"} />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", flexGrow: 1 }}>
          {
            pb.authStore.isValid 
              ? 
                <AdminExtension />
              : 
                <>
                  <IconButton color="inherit" onClick={toggleMode} sx={{ marginRight: "10px" }}>
                    {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                  </IconButton>
                  <Button color="inherit" href="/#admin">Bejelentkezés</Button>
                </>
          }
          </div>

        </Toolbar>
      </AppBar>
    </Box>
  );
}



function AdminExtension({setUser}) {
    
    const [ monogram, setMonogram ] = React.useState("");
    const [ color, setColor ] = React.useState("");
    const [ drawerOpen, setDrawerOpen ] = React.useState(false);
    const [ smsOpen, setSmsOpen ] = React.useState(false);
    const { mode, toggleMode } = useThemeMode();
    const pb = usePocketBase();


    function logout() {
        pb.authStore.clear();
        try {
            setUser("logout");
        } catch (error) {
            window.location.reload();
        }
    }

    React.useEffect(() => {
        if (!pb.authStore.isValid) {
            return;
        }
        const initials = pb.authStore.record.csaladNev.charAt(0).toUpperCase() + pb.authStore.record.keresztNev.charAt(0).toUpperCase();
        setMonogram(initials);

        const userId = pb.authStore.record.id;
        const base64 = btoa(userId);
        let r = base64.charCodeAt(0);
        let g = base64.charCodeAt(1);
        let b = base64.charCodeAt(2);
        const color = `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
        setColor(color);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return (
        <>
        <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>

          <Button color="inherit" startIcon={<PersonIcon />} href="/#">Főoldal</Button>
          <Button color="inherit" startIcon={<DashboardIcon />} href="/#admin" style={{ marginLeft: "10px"}}>Admin</Button>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setDrawerOpen(true)}
            edge="start"
            sx={[
              {
                marginLeft: "0px"
              }
            ]}
          >
            <MenuIcon />
          </IconButton>

        <Suspense>
          <SMSDialog open={smsOpen} setOpen={setSmsOpen} />
        </Suspense>
              <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <div style={{ width: "280px", padding: "20px 20px 0px 20px" }}>
          <h2 style={{ marginBottom: "3px"}}>ProEvent Rendezvénykezelő</h2>
          <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
          <SysCheck />
          </div>
          <hr />
        </div>
        <div style={{ width: "280px", padding: "0px 20px 20px 20px" }}>
          <h3>Adminisztráció</h3>
          <Button variant="contained" startIcon={<DashboardIcon />} color="primary" fullWidth onClick={() => window.location.href="/#admin"}>Admin Panel</Button>
          <Button variant="contained" startIcon={<SmsIcon />} color="primary" fullWidth style={{ marginTop: "10px" }} onClick={() => setSmsOpen(true)}>SMS küldése</Button>
          <Button variant="contained" startIcon={<StorageIcon />} color="primary" fullWidth style={{ marginTop: "10px" }} onClick={() => window.location.href="/#userSearch"}>Felhasználói adatbank</Button>
          <Button variant="contained" startIcon={<PollIcon />} color="primary" fullWidth style={{ marginTop: "10px" }} onClick={() => window.location.href="/#surveys"}>Értékelő kérdőívek</Button>
          <Button variant="contained" startIcon={<TextSnippetIcon />} color="primary" fullWidth style={{ marginTop: "10px" }} href="/#vfsList">Üzenet szerkesztő</Button>
        </div>
        <hr style={{ width: "240px" }} />
          <div style={{ width: "280px", display: "flex", alignItems: "center" }}>
          <Switch checked={mode === 'dark'} onChange={toggleMode} color="default" sx={{ marginLeft: "15px" }} />
          {mode === 'dark' ? <Typography variant="body1" sx={{ marginLeft: "10px" }}>Sötét mód</Typography> : <Typography variant="body1" sx={{ marginLeft: "10px" }}>Világos mód</Typography>}
          </div>
          <div style={{ width: "280px", padding: "20px", marginTop: "auto" }}>
            <hr />
            <h3>Felhasználói műveletek</h3>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px", flexDirection: "row", justifyContent: "right", alignContent: "center" }}>
              <Avatar sx={{ bgcolor: color, marginLeft: "10px" }} onClick={() => window.location.href="/#admin"}>{monogram}</Avatar>
              <p style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%" }}>&nbsp;&nbsp;{pb.authStore.record.csaladNev} {pb.authStore.record.keresztNev}</p>
              <Button variant="outline-danger" onClick={() => logout()}><LogoutIcon /></Button>
            </div>
          </div>
      </Drawer>
        </div>
        </>
    )
}

export { NagyNav };